<div class="detail">
    <div class="detail_tabs mb-4">
      <app-horizontal-tabs (actionEvent)="tabClicked($event)" [tabs]="[
          'BuyBox Winning',
          'Sales',
          'Competition',
          'Reprice Activity',
        ]" [activeTab]="activeTab"></app-horizontal-tabs>
    </div>
    <div class="detail_content">
      <ng-container>
        <div *ngIf="activeTab === 'BuyBox Winning'">
            <div class="dashboard_card-box graph">
                <div class="d-flex justify-content-between mb-3" >
                    <span class="title-text">Buy Box Winning</span>
                    <div class="day-detail" (click)="openDateDialog($event)">{{dateFilterButtonText?.buyboxwinning ? dateFilterButtonText.buyboxwinning : defaultFilterButtonText}}      
                      <div class="date-button_icon">
                        <i class="fas fa-caret-down"></i>
                      </div>
                    </div>
                </div> 
                <div id="buyBoxWinning" style="height: 210px;">
                    <app-bar-chart *ngIf="buyBoxWinningData" [id]="'buyBoxWinning'" [data]="buyBoxWinningData" [chartColors]="buyBoxWinningChartColors" [labels]="buyBoxWinninglabels" [yAxisLabelType]="'percentage'"></app-bar-chart>
                    <div  class="loader" *ngIf="buyBoxWinningLoading">
                      <img  src="assets/images/nineyard-loading.gif" >
                    </div> 
                </div>        
            </div>
        </div>
        <div *ngIf="activeTab === 'Sales'">
            <div class="dashboard_card-box graph">
            <div class="d-flex justify-content-between mb-3">
                <span class="title-text">Sales</span>
                <div class="day-detail" (click)="openDateDialog($event)">{{dateFilterButtonText?.sales ? dateFilterButtonText.sales : defaultFilterButtonText}}      
                  <div class="date-button_icon">
                    <i class="fas fa-caret-down"></i>
                  </div>
                </div>
            </div> 
            <div id="sales" style="height: 210px;">
                <app-bar-chart *ngIf="salesData" [id]="'sales'" [data]="salesData" [chartColors]="salesChartColors" [labels]="saleslabels" [yAxisLabelType]="'dollar'"></app-bar-chart>
                <div  class="loader" *ngIf="salesDataLoading">
                  <img  src="assets/images/nineyard-loading.gif" >
                </div> 
            </div>  
            </div>
        </div>
        <div *ngIf="activeTab === 'Competition'">
            <div class="dashboard_card-box graph">
              <div class="d-flex justify-content-between mb-3">
                <span class="title-text">Competition</span>
                <div class="day-detail" (click)="openDateDialog($event)">{{dateFilterButtonText?.competition ? dateFilterButtonText.competition : defaultFilterButtonText}}      
                  <div class="date-button_icon">
                    <i class="fas fa-caret-down"></i>
                  </div>
                </div>
            </div> 
            <div id="competition" style="height: 210px;">
                <app-bar-chart *ngIf="competitionData" [id]="'competition'" [data]="competitionData" [chartColors]="competitionChartColors" [labels]="competitionlabels"></app-bar-chart>
                <div  class="loader" *ngIf="competitionDataLoading">
                  <img  src="assets/images/nineyard-loading.gif" >
                </div> 
            </div> 
          </div>
        </div>
        <div *ngIf="activeTab === 'Reprice Activity'">
            <div class="dashboard_card-box graph">
              <div class="d-flex justify-content-between mb-3">
                <span class="title-text">Repricer Activity</span>
                <div class="day-detail" (click)="openDateDialog($event)">{{dateFilterButtonText?.repriceactivity ? dateFilterButtonText.repriceactivity : defaultFilterButtonText}}      
                  <div class="date-button_icon">
                    <i class="fas fa-caret-down"></i>
                  </div>
                </div>
            </div> 
            <div id="repriceActivity" style="height: 210px;">
                <app-lines-chart *ngIf="repriceActivityData" [id]="'repriceActivity'" [data]="repriceActivityData" [chartColors]="repriceActivityChartColors" [labels]="repriceActivitylabels" [yAxisLabelType]="'percentage'"></app-lines-chart>
                <div  class="loader" *ngIf="repriceActivityLoading">
                  <img  src="assets/images/nineyard-loading.gif" >
                </div> 
            </div>  
            </div>
        </div>
      </ng-container>
    </div>
  
  </div>